import React, {  } from 'react';

import { relativeTimeFormatOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { RelativeTimeFormatInput } from './Intl.RelativeTimeFormat';

export const IntlRelativeTimeFormatFormatToParts = () => (
	<IntlFunction
		input={RelativeTimeFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/formatToParts"
		header="Intl.RelativeTimeFormat.prototype.formatToParts"
		description="Returns an [Array](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array) of objects representing the relative time format in parts that can be used for custom locale-aware formatting."
		options={relativeTimeFormatOptions}
		ruleSet={[]}
		template="new Intl.RelativeTimeFormat(##locale##, ##options##).formatToParts(##input:raw##, ##input##)" />
)